import { useEffect } from 'react';

import { AnalyticsEvents, AnalyticsProps } from '@llura/constants';

import { trackEvent } from './umami';

// On mount fires `flow_step_entered`; on unmount fires `flow_step_completed`
// with the elapsed time. Drives the per-form time-on-step metric without
// every step component repeating the same boilerplate.
export function useStepTiming(stepName: string) {
  useEffect(() => {
    const startedAt = performance.now();
    trackEvent(AnalyticsEvents.FlowStepEntered, {
      [AnalyticsProps.StepName]: stepName,
    });
    return () => {
      trackEvent(AnalyticsEvents.FlowStepCompleted, {
        [AnalyticsProps.StepName]: stepName,
        [AnalyticsProps.DurationMs]: Math.round(performance.now() - startedAt),
      });
    };
  }, [stepName]);
}
